import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { AccountSettingService } from './account-setting.service';
import { AccountSettingActions } from './account-setting.actions';
import { UserAction } from '../../user/state/user.action';
import { Action } from '@ngrx/store';
import { AuthenticationActions } from '../../auth/state/authentication.actions';

@Injectable()
export class AccountSettingEffects {
    constructor(
        private actions$: Actions,
        private accountSettingService: AccountSettingService) {
    }

    getAccountSettingByUserId = createEffect(() =>
        this.actions$.pipe(
            ofType(AccountSettingActions.getAccountSettingsByUserId),
            switchMap((action: any) =>
                this.accountSettingService.getAccountSettingsByUserId(action.user.userId)
                    .pipe(
                        map((response: any) =>
                            AccountSettingActions
                                .getAccountSettingsByUserIdSuccess({settings: response.settings})
                        )
                    )
            )
        )
    );


}
